module.exports = __webpack_public_path__ + "static/media/waterday.537a72c4.png";